import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// pages
import { ComplaintsComponent } from '../../../pages/complaints/complaints.component';
import { FraudPreventionPage } from '../../../pages/fraud-prevention/fraud-prevention.page';
import { HelpModule } from './help.module';
import { CurrencyExchangeRatesComponent } from '../../../components/currency-exchange-rates/currency-exchange-rates.component';

const routes: Routes = [
  {
    path: 'faqs',
    loadChildren: () => import('../faqs/faqs.module').then((m) => m.FAQModule),
  },
  {
    path: 'help-and-support',
    redirectTo: `/${window.location.pathname.split('/')[1]}/help/faqs`,
  },
  {
    path: 'complaints',
    component: ComplaintsComponent,
    data: { title: 'Complaints' },
  },
  {
    path: 'fraud-prevention',
    component: FraudPreventionPage,
    data: { title: 'Fraud Prevention' },
  },
  {
    path: 'currency-exchange',
    component: CurrencyExchangeRatesComponent,
    data: { title: 'Currency Exchange' },
  },
  {
    path: 'contact-us',
    redirectTo: `/${
      window.location.pathname.split('/')[1]
    }/help/faqs/contact-us/contact-us`,
    pathMatch: 'full',
  },
];

export const routing: ModuleWithProviders<HelpModule> =
  RouterModule.forChild(routes);
